import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'receiving.enableDirectPlacement'.
 *
 * Gater HELE «direkte utlegg fra ordrelinje»-funksjonen (P19/P20) i varemottak:
 * når av skjules knappen «Legg direkte ut på lokasjon». Få kunder arbeider på denne
 * måten, så funksjonen er av som standard og aktiveres eksplisitt per tenant.
 *
 * Oppløsning følger hierarkiet Profile -> System -> Default via getEffectiveSetting
 * (SettingDefinition tillater kun System-nivå, så effektiv verdi = System).
 *
 * Default: false (av med mindre tenant eksplisitt slår den på).
 */
export function useDirectPlacementEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('receiving.enableDirectPlacement');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load receiving.enableDirectPlacement setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
